import { useCallback, useRef, useState } from 'react';

import { createClassName, createStyleHelper } from '../../utils/class-names';
import type { FCWithChildren } from '../../utils/component.interface';
import { Icon } from '../icon/icon';

import styles from './slider.module.scss';

const style = createStyleHelper(styles, 'slider');

export interface ISliderProps {
    className?: string;
    scrollWidthDivider: number;
}

export const SliderList: FCWithChildren<ISliderProps> = ({
    className,
    scrollWidthDivider,
    children,
}) => {
    const [isComponentHovered, setIsComponentHovered] = useState(false);
    const listRef = useRef<HTMLDivElement>(null);

    const move = useCallback(
        (direction: 'left' | 'right') => {
            const scrollAmount =
                ((listRef.current?.clientWidth ?? 0) / scrollWidthDivider) *
                (Math.floor(scrollWidthDivider) - 1);

            const scrollValue = direction === 'left' ? -scrollAmount : scrollAmount;

            listRef.current?.scrollBy(scrollValue, 0);
        },
        [listRef, scrollWidthDivider],
    );

    const handleMouseEnter = () => {
        setIsComponentHovered(true);
    };

    const handleMouseLeave = () => {
        setIsComponentHovered(false);
    };

    return (
        <div
            className={createClassName([className, style()])}
            ref={listRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div
                className={style('icon-bg', { left: true, visible: isComponentHovered })}
                onClick={() => move('left')}
            >
                <Icon className={style('icon')} name={'angle-left'} />
            </div>
            {children}
            <div
                className={style('icon-bg', { right: true, visible: isComponentHovered })}
                onClick={() => move('right')}
            >
                <Icon className={style('icon')} name={'angle-right'} />
            </div>
        </div>
    );
};
